import { getPinImages } from '../../utils/images';
import TrailCollection from './TrailCollection';

export default TrailCollection;

export const trailCollectionImages = getPinImages(['pinImage', 'clusterImage']);
